import { createAction } from '@ngrx/store';

export const getAll = createAction('[Country] getAll');

export const getDestination = createAction('[Country] getDestination');
